import { render, staticRenderFns } from "./ServiceAgreement_mobile.vue?vue&type=template&id=583a6e5a&scoped=true&"
import script from "./ServiceAgreement_mobile.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreement_mobile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAgreement_mobile.vue?vue&type=style&index=0&id=583a6e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a6e5a",
  null
  
)

export default component.exports